
(function ($) {

    this.init = function () {
        this.SkipLinks();
    };

    /****************************************************************
     SKIP LINKS
    ****************************************************************/

    this.SkipLinks = function () {

        $("#OLBSkip").on("click", function () {


            // If we're in mobile, else desktop
            if ($(window).outerWidth() < 991) {
                $(".onlinebanking-content-link").focus();
            } else {
                $("#onlineBankingType").focus();
            }
        });

    }
    this.init();

})(jQuery);